import { render } from "./notes.vue?vue&type=template&id=e86173f8&scoped=true&ts=true"
import script from "./notes.vue?vue&type=script&lang=ts"
export * from "./notes.vue?vue&type=script&lang=ts"

import "./notes.vue?vue&type=style&index=0&id=e86173f8&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86173f8"]])

export default __exports__